import { useMainContext } from "../../context";
import { languageEN } from "./../../languageEN";
import { languagePL } from "./../../languagePL";

export const LoadingModal = () => {
  const { language } = useMainContext();

  return (
    <div className="info_modal">
      <div className="loading_modal_background">
        <div className="loader_container">
          <div className="loader"></div>
        </div>

        <div>
          <p className="loading_modal_title">
            {language === "PL"
              ? languagePL.loaderTitle
              : languageEN.loaderTitle}
          </p>
        </div>
        <div>
          <p className="loading_modal_subtitle">
            {language === "PL" ? languagePL.loaderDesc : languageEN.loaderDesc}
          </p>
        </div>
      </div>
    </div>
  );
};
